// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__KeFTg","content":"Consent_content__17hCB","footer":"Consent_footer__3eWNi"};